// import { createI18n, LocaleMessages, LocaleMessageValue, VueMessageType } from 'vue-i18n';
//import VueI18n from 'vue-i18n'

/* export default createI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'it',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en'
  // messages: loadLocaleMessages(),
  // dateTimeFormats,
}); */

/* export async function createI18n (locale) {
  const i18n = new VueI18n({
    locale,
    fallbackLocale: 'en'
    // messages,
    // missing: missingTranslation
  })

  return i18n
} */

import it  from 'vuetify/lib/locale/it'
import fallback  from './lang/fallback.json' // Necessario solo se non è presente su db il documento backoffice_traduzioni
import configurazioni from '@/services/configurazioniService'

// const traduzioni = config.traduzioni

/* export default {
  ...it,
  ...traduzioni
} */

async function getTraduzioni(lang) {
  // Aggiungere le altre lingue necessarie
  const traduzioni = await configurazioni.getConfigurazione('backoffice_traduzioni', 'lingue')
  const td_default = traduzioni.default || fallback
  const td_it = traduzioni.it || fallback

  switch (lang) {
    case 'it':
      return {
        ...it,
        ...td_it
      }      
    default:
      return {
        ...it,
        ...td_default
      }      
  }
}
export default getTraduzioni
